/**
 * @generated SignedSource<<1b22804f7d23b1bb6ae2e301d6a4b87f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAcceptRulesButtonQuery$variables = {
  event: string;
};
export type EventAcceptRulesButtonQuery$data = {
  readonly viewer: {
    readonly entitiesHead?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly id: string;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserEntitiesAutocompleteFragment">;
  };
};
export type EventAcceptRulesButtonQuery = {
  response: EventAcceptRulesButtonQuery$data;
  variables: EventAcceptRulesButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "event"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v3 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "on",
      "variableName": "event"
    },
    {
      "kind": "Literal",
      "name": "to",
      "value": "CREATE_EVENT_RULE_AGREEMENT"
    }
  ],
  "kind": "ObjectValue",
  "name": "permission"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  },
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAcceptRulesButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "entitiesHead",
                "args": (v4/*:: as any*/),
                "concreteType": "UserEntitiesConnection",
                "kind": "LinkedField",
                "name": "entities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": [
                  (v3/*:: as any*/)
                ],
                "kind": "FragmentSpread",
                "name": "UserEntitiesAutocompleteFragment"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventAcceptRulesButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "entitiesHead",
                "args": (v4/*:: as any*/),
                "concreteType": "UserEntitiesConnection",
                "kind": "LinkedField",
                "name": "entities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v1/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  (v3/*:: as any*/)
                ],
                "concreteType": "UserEntitiesConnection",
                "kind": "LinkedField",
                "name": "entities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v1/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08649cc7c0ac773251d6d6d8f99de7a9",
    "id": null,
    "metadata": {},
    "name": "EventAcceptRulesButtonQuery",
    "operationKind": "query",
    "text": "query EventAcceptRulesButtonQuery(\n  $event: ID!\n) {\n  viewer {\n    __typename\n    id\n    username\n    ... on User {\n      entitiesHead: entities(first: 2, permission: {to: CREATE_EVENT_RULE_AGREEMENT, on: $event}) {\n        edges {\n          node {\n            __typename\n            id\n          }\n        }\n      }\n      ...UserEntitiesAutocompleteFragment_2YmnLC\n    }\n  }\n}\n\nfragment UserEntitiesAutocompleteFragment_2YmnLC on User {\n  id\n  username\n  entities(first: 10, permission: {to: CREATE_EVENT_RULE_AGREEMENT, on: $event}) {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f61025bef1aed5a9a57f216624b18ea0";

export default node;
